import Vue from 'vue'
import vueI18n from 'vue-i18n'

const messages = {
  th :require('@/lang/th.yml')
}

const options = {
  locale: 'th',
  messages,
  silentTranslationWarn: true
}

Vue.use(vueI18n)
const i18n = new vueI18n(options)

export default i18n